window.ShowPraemienResults = function() {
    let sourceForm = document.querySelector('.wsf-form.praemienvergleich');
    let targetForm = document.querySelector('.noss_praemienvergleich.default #noss_praemienvergleich_form');
    if (sourceForm !== undefined && targetForm !== undefined) {
        let zipCity = sourceForm.querySelector('.fld-zipcity').value;
        let birthYears = sourceForm.querySelectorAll('.fld-birthyear');
        let franchises = sourceForm.querySelectorAll('.fld-franchise');
        let accidents = sourceForm.querySelectorAll('.fld-accident:not([data-hidden])');

        let persons = [];

        for (let i = 0; i < birthYears.length; i++) {
            persons.push({
                'birthyear': parseInt(birthYears[i].value),
                'franchise': parseInt(franchises[i].value),
                'accident': accidents[i].checked,
            })
        }

        targetForm.querySelector('#zipcity').value = zipCity;
        targetForm.querySelector('#persons').value = JSON.stringify(persons);

        const data = new URLSearchParams();
        for (const pair of new FormData(targetForm)) {
            data.append(pair[0], pair[1]);
        }

        fetch(targetForm.dataset.endpoint, {
            method: 'POST',
            body: data
        }).then(function (response) {
            if (response.ok) {
                return response.text();
            }
            return Promise.reject(response);
        }).then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            targetForm.closest('div').querySelector('.items').innerHTML = html;
        }).catch(function (error) {
            console.warn('Something went wrong.', error);
        });
    }
}